import { CommandHandler } from '../../_base/actionBus/CommandHandler';
import { AuthService } from '../../models/auth/AuthService';
import { SessionStorage } from '../../models/session/SessionStorage';
import { RefreshSession } from './RefreshSession';

export class RefreshSessionHandler implements CommandHandler<RefreshSession> {
    constructor(private authService: AuthService, private sessionStorage: SessionStorage) {}

    async handle(_: RefreshSession) {
        const session = await this.sessionStorage.get();
        if (!session.isAuthenticated) return;
        try {
            const user = await this.authService.me();
            await this.sessionStorage.do(s => { s.user = user; });
        } catch {
            // swallow — refresh is best-effort; stale session is acceptable
        }
    }
}
